import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cc-charts-list-toolbar',
  templateUrl: './charts-list-toolbar.component.html',
  styleUrls: [
    '../../../../../styles/components/tool-bar.component.scss',
    './charts-list-toolbar.component.scss',
  ],
})
export class ChartsListToolbarComponent {
  @Input() selectedCharts;
  @Input() dashboard;
  @Input() charts;
  @Input() canAdd;

  @Output() deleteSelected = new EventEmitter();
  @Output() addChart = new EventEmitter();
}
